import { Component } from 'preact';
import propTypes from 'prop-types';

import DetailTabs from '../DetailTabs';
import AccordionVehicle from '../AccordionVehicle';

export default class VehicleDetailsModal extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isOpen: false,
    };

    this.handleModalToggle = this.handleModalToggle.bind(this);
    this.handleClickOutside = this.handleClickOutside.bind(this);
  }

  componentDidMount() {
    const openModalTriggerElement = document.querySelector(
      this.props.openModalTriggerSelector,
    );

    if (!openModalTriggerElement) return;

    openModalTriggerElement.addEventListener('click', this.handleModalToggle);
  }

  handleModalToggle(value) {
    const modalNewState =
      typeof value === 'boolean' ? value : !this.state.isOpen;

    this.setState(oldState => ({
      ...oldState,
      isOpen: modalNewState,
    }));
  }

  handleClickOutside(event) {
    if (this.modalContentRef && !this.modalContentRef.contains(event.target)) {
      this.handleModalToggle(false);
    }
  }

  render() {
    const { modelName, tabsBg } = this.props;

    return (
      // eslint-disable-next-line jsx-a11y/no-static-element-interactions
      <div
        className="custom-modal vehicle-details__modal"
        data-open={this.state.isOpen}
        onClick={this.handleClickOutside}
        onKeyDown={this.handleClickOutside}
      >
        <div className="custom-modal__overlay">
          <div
            className="custom-modal__content container"
            ref={node => {
              this.modalContentRef = node;
            }}
          >
            <section className="vehicle-details__info">
              <div className="vehicle-details__info-header">
                <p className="vehicle-details__info-header-subtitle">
                  Ficha técnica
                </p>

                <h2 className="vehicle-details__info-header-title">
                  {modelName}
                </h2>

                <button
                  className="custom-modal__button-close"
                  onClick={this.handleModalToggle}
                  aria-label="Fechar"
                  type="button"
                >
                  <i className="icon icon-close" />
                </button>
              </div>
              <div
                className="vehicle-details__tabs d-none d-md-block"
                style={`background-image: url('${tabsBg}')`}
              >
                <DetailTabs />
              </div>
              <div className="vehicle-details__accordion d-md-none">
                <AccordionVehicle />
              </div>
            </section>
          </div>
        </div>
      </div>
    );
  }
}

VehicleDetailsModal.defaultProps = {
  openModalTriggerSelector: null,
  modelName: '',
  tabsBg: '',
};

VehicleDetailsModal.propTypes = {
  openModalTriggerSelector: propTypes.string,
  modelName: propTypes.string,
  tabsBg: propTypes.string,
};
